import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.to-string";

var RemoteMongoCursor = function () {
  function RemoteMongoCursor(proxy) {
    this.proxy = proxy;
  }

  RemoteMongoCursor.prototype.next = function () {
    return Promise.resolve(this.proxy.next().value);
  };

  return RemoteMongoCursor;
}();

export default RemoteMongoCursor;